/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

// (function() {

// Below are example event listeners.  They listen for theme events that Pipeline
// fires in order to make it easier for you to add customizations.

// Keep your scripts inside this IIFE function call to avoid leaking your
// variables into the global scope.

// document.addEventListener('theme:variant:change', function(event) {
// You might use something like this to write a pre-order feature or a
// custom swatch feature.
// var variant = event.detail.variant;
// var container = event.target;
// if (variant) {
//   console.log('Container ———————— ↓');
//   console.log(container);
//   console.log('Variant —————————— ↓');
//   console.log(variant);
// ... update some element on the page
//   }
// });

// document.addEventListener('theme:cart:change', function(event) {
//   var cart = event.detail.cart;
//   if (cart) {
//     console.log('Cart ———————————— ↓');
//     console.log(cart);
// ... update an app or a custom shipping caluclator
//   }
// });
// Fired when page loads to update header values
// document.addEventListener('theme:cart:init', (e) => {
//   console.log('theme:cart:init');
//   console.log(e);
// });

// Debounced scroll listeners.  Up and down only fire on direction changes
// These events are useful for creating sticky elements and popups.
// document.addEventListener('theme:scroll', e => { console.log(e); });
// document.addEventListener('theme:scroll:up', e => { console.log(e); });
// document.addEventListener('theme:scroll:down', e => { console.log(e); });

// Debounced resize listener to bundle changes that trigger document reflow
// document.addEventListener('theme:resize', e => { console.log(e); });

// Locks and unlocks page scroll for modals and drawers
// These are commented out because firing them will lock the page scroll
// the lock event must set `detail` to the modal or drawer body so the
// scroll locking code knows what element should maintain scoll.
// document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
// document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

// ^^ Keep your scripts inside this IIFE function call to avoid leaking your
// variables into the global scope.
// })();

document.addEventListener("DOMContentLoaded", function () {
  // Collapsible Functionality
  var collapsibleItems = document.querySelectorAll(".collapsible");
  collapsibleItems.forEach(function (item) {
    item.addEventListener("click", function () {
      var content = this.nextElementSibling;
      this.classList.toggle("activee");
      if (this.classList.contains("activee")) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    });
  });

  // Accordion Functionality
  var acc = document.getElementsByClassName("accordion");
  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  // Tab navigation
  var tabs = document.querySelectorAll(".ProductTabs_wrapper li a");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      var sectionId = this.getAttribute("href");
      var content = this.closest(".ProductTabs__content");

      content.querySelectorAll(".ProductTab_TextContent").forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });
      content.querySelectorAll(".ProductTabs_TabHeading").forEach(function (tabHeading) {
        tabHeading.classList.remove("active");
      });

      this.parentElement.classList.add("active");
      document.querySelector(sectionId).classList.add("active");
    });
  });

  // Accordion Toggle for .js_ingredients_section
  document.querySelectorAll('.js_ingredients_section .accordion__title').forEach(function (accordionTitle) {
    accordionTitle.addEventListener('click', function (e) {
      e.preventDefault();
      var currentEl = this;
      var parentEl = currentEl.closest('.accordion__wrapper');
      if (currentEl.classList.contains('accordion-is-open')) {
        currentEl.classList.remove('accordion-is-open');
        parentEl.classList.remove('accordion_open');
        parentEl.querySelector('.accordion__body').style.display = 'none';
      } else {
        currentEl.classList.add('accordion-is-open');
        parentEl.classList.add('accordion_open');
        parentEl.querySelector('.accordion__body').style.display = 'block';
      }
    });
  }); 

  // Accordion Toggle for .new_js_ingredients_section
  document.querySelectorAll('.new_js_ingredients_section .accordion__title').forEach(function (accordionTitle) {
    accordionTitle.addEventListener('click', function (e) {
      e.preventDefault();
      var currentEl = this;
      var parentEl = currentEl.closest('.accordion__wrapper');
      if (currentEl.classList.contains('accordion-is-open')) {
        currentEl.classList.remove('accordion-is-open');
        parentEl.classList.remove('accordion_open');
        parentEl.querySelector('.accordion__body').style.display = 'none';
      } else {
        currentEl.classList.add('accordion-is-open');
        parentEl.classList.add('accordion_open');
        parentEl.querySelector('.accordion__body').style.display = 'block';
      }
    });
  });
});
